<template>
  <div class="p-4">
    <h2 class="text-center">购买说明</h2>
    <p>1.一车一码绑定，购买后永久有效、永久免费升级</p>
    <p>2.系统自动激活，购买后不支持退款，请确定需要再购买</p>
    <p>3.部分车型车机没有GPS天线，需要自行加装(淘宝可购买)，否则导航无法定位。<a href="#gps" style="color:black;text-decoration:underline">具体点此查看</a></p>
    <p>4.本页面仅做信息说明使用，<font color="red">购买请直接在车机上点击「确定购买」按钮，</font>再手机扫码支付即可</p>
    <table class="table table-bordered">
      <thead class="thead-light">
        <tr>
          <th>中控大师专业版主要功能</th>
          <th>
          <s>原价：199元</s><br />
          特惠价：99元</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>一次购买，永久免费</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
         <tr>
          <td>开机自动点击同意按钮</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>下载安装所有软件</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>下载所有开机视频</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>仪表盘同屏显示中控屏内容</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>仪表盘显示导航信息</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>仪表盘显示数字车速</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>仪表盘显示自定义图片（车辆、蘑菇头跳舞等可自由设置）</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>中控地图随时联网免费更新</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>自定义方向盘和中控屏幕按键功能</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>中控安装导航和音乐共存</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
        <tr>
          <td>开机自动启动应用（比如：QQ音乐、高德地图等）</td>
          <td><van-icon name="checked" color="green" /></td>
        </tr>
      </tbody>
    </table>
    <p class="m1">完整功能列表请关注微信公众号「中控大师」查看版本更新内容</p>
    <p><strong>注：专业版为全功能版本，可以使用中控大师软件的所有功能，包括后续更新增加的功能，都可以免费升级更新。仪表盘显示导航信息仅支持中控后安装的高德地图</strong></p>
    </div>
</template>

<script>
export default {
  name: "Price",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      table: {
        data: [],
      },
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
  filters: {},
};
</script>

